import { ChangeDetectionStrategy, Component, EventEmitter, NgModule, Output } from '@angular/core';
import { CejV2CanIBenefitModule } from '@domains/cej-v2/cej-v2-can-i-benefit/cej-v2-can-i-benefit.component';
import { CejV2WhatAreWeDoingModule } from '@domains/cej-v2/cej-v2-what-are-we-doing/cej-v2-what-are-we-doing.component';
import { CejV2WhatDoIGainModule } from '@domains/cej-v2/cej-v2-what-do-i-gain/cej-v2-what-do-i-gain.component';

@Component({
  selector: 'app-cej-v2-advantages',
  templateUrl: './cej-v2-advantages.component.html',
  styleUrls: ['./cej-v2-advantages.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CejV2AdvantagesComponent {
  @Output() canBenefitButtonClick: EventEmitter<void> = new EventEmitter();
}

@NgModule({
  imports: [CejV2CanIBenefitModule, CejV2WhatAreWeDoingModule, CejV2WhatDoIGainModule],
  declarations: [CejV2AdvantagesComponent],
  exports: [CejV2AdvantagesComponent],
})
export class CejV2AdvantagesModule {}
